import axios from "axios";
import { GET_LANGUAGES } from "./types";
const PROXY = process.env.REACT_APP_URL + "api/";

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};
// /api/label/get-language?language_code=en
export const getLanguages = (code = "en") => async (dispatch) => {
  const res = await axios.get(PROXY + `label/app/get?language_code=${code}`);

  let found = res?.data?.result?.find((element) => element.default === 1);

  // localStorage.setItem("i18next",found?.language_code);
  dispatch({
    type: GET_LANGUAGES,
    payload: res.data.result,
  });
  return res.data.result;
};
